import { Injectable } from '@angular/core';

import { ToasterService, ToasterContainerComponent, ToasterConfig } from 'angular2-toaster/angular2-toaster';

@Injectable()
export class ToasterUtilService {

    private toasterService: ToasterService;
    toastHide: boolean = false;

    toaster: any;
    toasterConfig: any;
    toasterconfig: ToasterConfig = new ToasterConfig({
        positionClass: 'toast-top-right',
        showCloseButton: true,
        mouseoverTimerStop: true,
        timeout: 8000
    });

    constructor(toasterService: ToasterService) {
        this.toaster = {
            type: '',
            title: '',
            text: ''
        };

        this.toasterService = toasterService;
    }

    pop(type: string, title: string, text: string) {
        this.toasterService.pop(type,title,text);
    };

    alerta(msg: string) {
        this.pop('warning','Alerta', msg);
    }

    info(msg: string) {
        this.pop('info','Informação', msg);
    }

    sucesso(msg: string) {
        this.pop('success','Sucesso', msg);
    }

     erro(msg: string) {
        this.pop('error','Erro', msg);
    }

}


// WEBPACK FOOTER //
// ./src/app/util/toaster-util.service.ts